import { SvgWrapper } from 'components/svgs/SvgWrapper/SvgWrapper';

export const AltaVisitorSvg = ({ ...svgProps }) => (
  <SvgWrapper
    data-testid="native-app-visitor-icon"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    {...svgProps}
  >
    <g clipPath="url(#clip0_711_7055)">
      <path
        opacity="0.6"
        d="M25.2795 -6.27604C25.8002 -6.79674 26.6442 -6.79674 27.1649 -6.27604C27.6856 -5.75534 27.6856 -4.91132 27.1649 -4.39062L16.9427 5.8316C16.422 6.3523 15.578 6.3523 15.0573 5.8316L5.2795 -3.94618C4.7588 -4.46688 4.7588 -5.3109 5.2795 -5.8316C5.8002 -6.3523 6.64422 -6.3523 7.16492 -5.8316L16 3.00347L25.2795 -6.27604Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7778 8C23.4933 8 24.8889 9.39556 24.8889 11.1111V28.8889C24.8889 30.6044 23.4933 32 21.7778 32H10.2222C8.50664 32 7.11108 30.6044 7.11108 28.8889V11.1111C7.11108 9.39556 8.50664 8 10.2222 8H21.7778ZM12 24C11.2622 24 10.6666 24.5956 10.6666 25.3333C10.6666 26.0711 11.2622 26.6667 12 26.6667H20C20.7378 26.6667 21.3333 26.0711 21.3333 25.3333C21.3333 24.5956 20.7378 24 20 24H12ZM16 13.3333C14.0363 13.3333 12.4444 14.9252 12.4444 16.8889C12.4444 18.8526 14.0363 20.4444 16 20.4444C17.9637 20.4444 19.5555 18.8526 19.5555 16.8889C19.5555 14.9252 17.9637 13.3333 16 13.3333Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_711_7055">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </SvgWrapper>
);
